import { render, staticRenderFns } from "./Y67TSecondarySummaryReport.vue?vue&type=template&id=48ec8525&scoped=true&"
import script from "./Y67TSecondarySummaryReport.vue?vue&type=script&lang=js&"
export * from "./Y67TSecondarySummaryReport.vue?vue&type=script&lang=js&"
import style0 from "./Y67TSecondarySummaryReport.vue?vue&type=style&index=0&id=48ec8525&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ec8525",
  null
  
)

export default component.exports